import React from "react";
import UzeliLogo from "../../../assets/images/growthzilla-logo.png";
export default function Header() {
  return (
    <div className="flex w-full   justify-start bg-[#f6f6f6] p-2   rounded-sm">
      <img src={UzeliLogo} className="h-[40px] md:h-full  " alt="logo" />
    </div>
  );
}
